/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountBillingEntityQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountBillingEntityQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly billingEntity: GraphQL.SubscriptionsSellerCode } | null };


export const AccountBillingEntityDocument = gql`
    query AccountBillingEntity($accountId: AccountId!) {
  account(id: $accountId) {
    id
    billingEntity
  }
}
    `;

/**
 * __useAccountBillingEntityQuery__
 *
 * To run a query within a React component, call `useAccountBillingEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBillingEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBillingEntityQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountBillingEntityQuery(baseOptions: Apollo.QueryHookOptions<AccountBillingEntityQuery, AccountBillingEntityQueryVariables> & ({ variables: AccountBillingEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountBillingEntityQuery, AccountBillingEntityQueryVariables>(AccountBillingEntityDocument, options);
      }
export function useAccountBillingEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountBillingEntityQuery, AccountBillingEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountBillingEntityQuery, AccountBillingEntityQueryVariables>(AccountBillingEntityDocument, options);
        }
export function useAccountBillingEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountBillingEntityQuery, AccountBillingEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountBillingEntityQuery, AccountBillingEntityQueryVariables>(AccountBillingEntityDocument, options);
        }
export type AccountBillingEntityQueryHookResult = ReturnType<typeof useAccountBillingEntityQuery>;
export type AccountBillingEntityLazyQueryHookResult = ReturnType<typeof useAccountBillingEntityLazyQuery>;
export type AccountBillingEntitySuspenseQueryHookResult = ReturnType<typeof useAccountBillingEntitySuspenseQuery>;
export type AccountBillingEntityQueryResult = Apollo.QueryResult<AccountBillingEntityQuery, AccountBillingEntityQueryVariables>;